module.exports = __webpack_public_path__ + "img/logo.d681db8.svg";